import React, { useState } from "react";
import { Link } from "react-router-dom";
import Category from "../Category/Category";
import "./Home.css";
const Home = () => {
  const types = [
    {
      imgUrl: "https://i.ibb.co/kBKHRNZ/bike.jpg",
      bookType: "bike",
    },
    {
      imgUrl:
        "https://i.ibb.co/2jT2QGj/pngtree-luxury-modern-convertible-car-png-image-1040396.jpg",
      bookType: "car",
    },
    {
      imgUrl: "https://i.ibb.co/WWTW79T/tour-bus-clipart-5.png",
      bookType: "bus",
    },
    {
      imgUrl:
        "https://i.ibb.co/GVpW4Qc/kisspng-china-train-rail-transport-high-speed-rail-industr-subway-5a6e25d1d6bd22-7147793815171680818.jpg",
      bookType: "train",
    },
  ];
  return (
    <div className="row">
      {types.map((type) => (
        <Category type={type}></Category>
      ))}
    </div>
  );
};

export default Home;
